export const MAX_RAFFLE_IMAGES = 12;

export const raffleImages = (raffle) => [...new Set(
    (raffle?.prize_image_urls ?? [raffle?.prize_image_url]).filter(url => typeof url === "string" && url.trim())
)];